import React, { isValidElement, ReactElement } from "react";
import { useTranslate } from "react-admin";
import MuiTab from "@material-ui/core/Tab";
import classnames from "classnames";

interface Props {
  children?: React.ReactNode;
  basePath?: string;
  className?: string;
  classes?: Partial<Record<"errorTabButton" | "content", string>>;
  hidden?: boolean;
  icon?: ReactElement;
  intent?: "header" | "content";
  label: string | ReactElement;
  margin?: "none" | "normal" | "dense";
  path?: string;
  resource?: string;
  value?: string | number;
  variant?: "standard" | "outlined" | "filled";
}

export const HookFormTabHeader = ({
  classes,
  label,
  value,
  icon,
  className,
  children,
  ...rest
}: Props) => {
  const translate = useTranslate();

  return (
    <MuiTab
      component="a"
      label={isValidElement(label) ? label : translate(label, { _: label })}
      value={value}
      icon={icon}
      className={classnames("form-tab", className)}
      id={`tabheader-${value}`}
      aria-controls={`tabpanel-${value}`}
      {...rest}>
      {children}
    </MuiTab>
  );
};
